import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "@/views/layout/Wrapper.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    meta: { title: '用户登录--$' },
    component: (resolve) => require(["@/views/account/Login.vue"], resolve),
  },
  {
    path: "/forgetPwd",
    meta: { title: '忘记密码--$' },
    component: (resolve) => require(["@/views/account/Layout.vue"], resolve),
    children: [
      {
        path: "",
        component: (resolve) =>
          require(["@/views/account/ForgetPwd.vue"], resolve),
      },
    ],
  },
  {
    path: "/register",
    meta: { title: '用户注册--$' },
    component: (resolve) =>
      require(["@/views/account/Layout.vue"], resolve),
    children: [
      {
        path: "",
        component: (resolve) =>
          require(["@/views/account/register/Index.vue"], resolve),
      },
      {
        path: "success",
        component: (resolve) =>
          require(["@/views/account/register/Success.vue"], resolve),
      },
    ],
  },
  {
    path: "/",
    name: "Layout",
    component: Layout,
    children: [
      {
        path: "",
        meta: { title: '$' },
        redirect: "index",
      },
      {
        path: "index",
        meta: { title: '$' },
        component: (resolve) => require(["@/views/layout/Index.vue"], resolve),
      },

      {
        path: "person/info",
        title: "个人账号信息",
        component: (resolve) => require(["@/views/person/Info.vue"], resolve),
      },
      {
        path: "person/modifyPwd",
        title: "修改密码",
        component: (resolve) =>
          require(["@/views/person/ModifyPwd.vue"], resolve),
      },
      {
        path: "article/add",
        title: "立即投稿",
        component: (resolve) => require(["@/views/article/Add.vue"], resolve),
      },

      {
        path: "article/myArticleReceive",
        title: "已录用稿件",
        component: (resolve) =>
          require(["@/views/article/MyArticleReceive.vue"], resolve),
      },
      {
        path: "article/myArticleRunning",
        title: "投稿中稿件",
        component: (resolve) =>
          require(["@/views/article/MyArticleRunning.vue"], resolve),
      },

      {
        path: "article/myArticleRejected",
        title: "被退稿稿件",
        component: (resolve) =>
          require(["@/views/article/MyArticleRejected.vue"], resolve),
      },
      {
        path: "article/myPayList",
        title: "支付记录",
        component: (resolve) =>
          require(["@/views/article/MyPayList.vue"], resolve),
      },
      {
        path: "article/myInvoiceList",
        title: "发票申请及记录",
        component: (resolve) =>
          require(["@/views/article/MyInvoiceList.vue"], resolve),
      },
      {
        path: "article/myRefundList",
        title: "退款申请及记录",
        component: (resolve) =>
          require(["@/views/article/MyRefundList.vue"], resolve),
      },

      /*编辑 */
      {
        path: "editor/article0",
        title: "稿件池",
        component: (resolve) =>
          require(["@/views/editor/article0.vue"], resolve),
      },

      {
        path: "editor/article1",
        title: "待评审稿件",
        component: (resolve) =>
          require(["@/views/editor/article1.vue"], resolve),
      },

      {
        path: "editor/article2",
        title: "已评审稿件",
        component: (resolve) =>
          require(["@/views/editor/article2.vue"], resolve),
      },


      {
        path: "editor/bmf0",
        title: "待登记版面费稿件",
        component: (resolve) =>
          require(["@/views/editor/bmf0.vue"], resolve),
      },

      {
        path: "editor/bmf1",
        title: "已登记版面费稿件",
        component: (resolve) =>
          require(["@/views/editor/bmf1.vue"], resolve),
      },

      {
        path: "editor/bmf3",
        title: "版面费缴纳情况查询",
        component: (resolve) =>
          require(["@/views/editor/bmf3.vue"], resolve),
      },
      {
        path: "editor/articleAccepted",
        title: "已录用稿件",
        component: (resolve) =>
          require(["@/views/editor/articleAccepted.vue"], resolve),
      },
      {
        path: "editor/remark",
        title: "评审意见配置",
        component: (resolve) =>
          require(["@/views/person/remark.vue"], resolve),
      },


      /*专家*/
      {
        path: "expert/article0",
        component: (resolve) =>
          require(["@/views/expert/article0.vue"], resolve),
      },
      {
        path: "expert/article1",
        component: (resolve) =>
          require(["@/views/expert/article1.vue"], resolve),
      },
      {
        path: "expert/article2",
        component: (resolve) =>
          require(["@/views/expert/article2.vue"], resolve),
      },
      {
        path: "expert/remark",
        component: (resolve) =>
          require(["@/views/person/remark.vue"], resolve),
      },

      /*查重员 */
      {
        path: "recheck/reportExpert",
        title: "专家审稿统计",
        component: (resolve) =>
          require(["@/views/recheck/reportExpert.vue"], resolve),
      },
      {
        path: "recheck/dc0",
        component: (resolve) =>
          require(["@/views/recheck/dc0.vue"], resolve),
      },
      {
        path: "recheck/dc1",
        component: (resolve) =>
          require(["@/views/recheck/dc1.vue"], resolve),
      },
      {
        path: "recheck/dc2",
        component: (resolve) =>
          require(["@/views/recheck/dc2.vue"], resolve),
      },
      {
        path: "recheck/articleAccepted",
        component: (resolve) =>
          require(["@/views/recheck/articleAccepted.vue"], resolve),
      },

      /*财务人员 */
      {
        path: "finance/receivedList",
        component: (resolve) =>
          require(["@/views/finance/ReceivedList.vue"], resolve),
      },
      {
        path: "finance/refundList1",
        component: (resolve) =>
          require(["@/views/finance/RefundList1.vue"], resolve),
      },
      {
        path: "finance/refundList2",
        component: (resolve) =>
          require(["@/views/finance/RefundList2.vue"], resolve),
      },

      {
        path: "finance/invoiceList1",
        component: (resolve) =>
          require(["@/views/finance/InvoiceList1.vue"], resolve),
      },

      {
        path: "finance/invoiceList2",
        component: (resolve) =>
          require(["@/views/finance/InvoiceList2.vue"], resolve),
      },
      {
        path: "finance/statistics",
        component: (resolve) =>
          require(["@/views/finance/Statistics.vue"], resolve),
      },

      /*管理员*/

      {
        path: "basic/setting",
        component: (resolve) => require(["@/views/basic/Setting.vue"], resolve),
      },
      {
        path: "basic/adminUser",
        component: (resolve) =>
          require(["@/views/basic/AdminUser.vue"], resolve),
      },
      {
        path: "basic/subject",
        component: (resolve) => require(["@/views/basic/Subject.vue"], resolve),
      },

      {
        path: "users/list",
        component: (resolve) => require(["@/views/users/List.vue"], resolve),
      },
    ],
  },
];

const router = new VueRouter({
  routes,
});

export default router;
